define((require) => {
    "use strict";

    const ImprovedModel = require("shared/zbone/ImprovedModel");

    const Placement = {
        BEFORE: "before",
        AFTER: "after"
    };

    /**
     * ButtonIconModel is the model for the Icon part of a Button Widget.
     */
    return ImprovedModel.extend("ButtonIconModel", {
        defaults: {
            iconId: null,
            name: null,
            groupId: null,
            size: 24,
            placement: Placement.AFTER,
            color: "#FFFFFF"
        },

        getIconUrl() {
            const {groupId, iconId, size} = this.pick(["groupId", "iconId", "size"]);

            return `images/material-design-icons/${groupId}/svg/production/ic_${iconId}_${size}px.svg`;
        }

    }, {

        Placement

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/button/ButtonIconModel.js